
<template>

	<div :style="level > 0 ? 'padding-left: 5px; border-left: 5px solid ' + ( level > colors.length - 1 ? 'gray' : colors[level] ) : ''">

		<b-button v-if="need_delete_button" size="sm" variant="light" class="filter-button" v-on:click="() => $emit('delete')" ><b-icon-trash/></b-button>
		<b-row class="mt-2">

			<b-col cols="1" md="auto" style="padding-right: 0px"><div style="width: 60px">Если</div></b-col>
			<b-col style="padding-left: 0px"><condition ref="condition" class="script" :level="0" :attrs="attrs" :attr_type="attr_type" :in_doing="in_doing" v-on:need_check="() => $emit('need_check')"/></b-col>

		</b-row>

		<b-row class="mt-2">

			<b-col cols="1" md="auto" style="padding-right: 0px"><div style="width: 60px">То</div></b-col>
			<b-col style="padding-left: 0px"><stage ref="cond_true" class="script" :level="0" :attrs="attrs" :attr_type="attr_type" :attr_reference="attr_reference" :in_doing="in_doing" v-on:need_check="() => $emit('need_check')" :is_correction="is_correction" :is_correction_mult="is_correction_mult" /></b-col>

		</b-row>

		<b-row class="mt-2">

			<b-col cols="1" md="auto" style="padding-right: 0px"><div style="width: 60px">Иначе</div></b-col>
			<b-col style="padding-left: 0px"><stage ref="cond_false" class="script" :level="0" :attrs="attrs" :attr_type="attr_type" :attr_reference="attr_reference" :in_doing="in_doing" v-on:need_check="() => $emit('need_check')" :is_correction="is_correction" :is_correction_mult="is_correction_mult" /></b-col>

		</b-row>

	</div>

</template>

<script>

import condition from "./condition"

export default
{
	name : "branch",

	props :
	{
		attrs : Array,
		attr_type : String,
		attr_reference : Object,
		level : { type : Number, default : () => 0 },
		need_delete_button : Boolean,
		in_doing : Boolean,
		is_correction : { type : Boolean, default : () => false },
		is_correction_mult : { type : Boolean, default : () => false },
	},

	components :
	{
		condition,
	},

	data()
	{
		return {

			colors : [ "red", "green", "blue", "yellow", "orange", "violet" ],

		}
	},

	beforeCreate()
	{
		this.$options.components.stage = require("./stage.vue").default
	},

	methods :
	{
		get()
		{
			var desc = {}

			desc.condition = this.$refs.condition.get()
			desc.cond_true = this.$refs.cond_true.get()
			desc.cond_false = this.$refs.cond_false.get()

			return desc
		},

		load(desc)
		{
			this.$nextTick(
				() =>
				{
					this.$refs.condition.load(desc.condition)
					this.$refs.cond_true.load(desc.cond_true)
					this.$refs.cond_false.load(desc.cond_false)
				})
		},
	}
}

</script>

<style scoped>
.script
{
	border: 1px solid var(--bft-neutral-300);
	border-radius: 4px;
	padding: 8px;
}
</style>
